export const findAreaById = (allAreas, areaId) => {
  var oldArea = null;

  for (var i in allAreas) {
    const area = allAreas[i];
    if (
      area.areaId == areaId ||
      (typeof areaId === "string" && area.areaUId == areaId)
    ) {
      oldArea = { ...area };
      break;
    }
  }
  return oldArea;
};

export const findMainParent = (allAreas, currentArea) => {
  if (currentArea.parentAreaId || currentArea.parentAreaUId) {
    var prnt = findAreaById(
      allAreas,
      currentArea.parentAreaId || currentArea.parentAreaUId
    );
    if (!prnt) {
      return currentArea;
    } else if (prnt.isMainArea) {
      return prnt;
    } else {
      return findMainParent(allAreas, prnt);
    }
  }
  return currentArea;
};

export const GetTree = (allAreas) => {
  var mainAreaIds = [];
  allAreas.filter((a) => {
    if (a.isMainArea) {
      mainAreaIds.push(a.areaId || a.areaUId);
    }
  });

  var rootNode = {
    areaId: -1,
    areaUId: null,
    areaName: "",
    subAreas: allAreas.filter((a) => {
      const _areaId =
        findMainParent(allAreas, a).areaId ||
        findMainParent(allAreas, a).areaUId;
      if (a.isMainArea || mainAreaIds.indexOf(_areaId) < 0) {
        mainAreaIds.push(a.areaId || a.areaUId);
        return a.areaId || a.areaUId;
      }
    }),
  };
  return rootNode;
};

export const getActionReverseDictionary = (
  actionManagers = [],
  actions = []
) => {
  let dictionary = [];
  let actionReversList = actionManagers
    .filter(
      (am) =>
        actions.length == 0 ||
        actions.map((a) => a.manager).includes(am.manager)
    )
    .map((m) => {
      return {
        manager: m.manager,
        actions: m.actions
          .filter(
            (a) =>
              actions.length == 0 ||
              (a.reverse && actions.map((ac) => ac.action).includes(a.action))
          )
          .map((a) => {
            return { action: a.action, reverse: a.reverse };
          }),
      };
    });

  for (var m in actionReversList) {
    for (var a in actionReversList[m].actions)
      if (actionReversList[m].actions) {
        dictionary.push({
          manager: actionReversList[m].manager,
          action: actionReversList[m].actions[a].action,
          reverse: actionReversList[m].actions[a].reverse,
        });
      }
  }

  return dictionary;
};
